var Staging = {
  apiUrl: 'https://gateway.stg.hummingbirdtech.com/api',
  bucketUrl: 'https://www.googleapis.com/upload/storage/v1/b/hbt-staging-ortho-raw/o?uploadType=resumable',
  googleMapsApiKey: 'AIzaSyCIbJEGHxLAP_kSWXQ1jUGknbRmcgSy5j8',
  analysisTileUrl: 'https://storage.googleapis.com/hbt-staging-maps',
  accountsUrl: 'https://fresh-accounts.stg.hummingbirdtech.com/',
  appUrl: 'https://fresh.staging.hummingbirdtech.com/',
  freshUrl: 'https://fresh.staging.hummingbirdtech.com/',
  adminUrl: 'https://fresh-admin.staging.hummingbirdtech.com/',
  applicationUrl: 'https://fresh-applications.staging.hummingbirdtech.com/',
  uploaderUrl: 'https://uploader.staging.hummingbirdtech.com/',
  downloadApplicationFileReportSheetUrl: 'https://script.google.com/a/hummingbirdtech.com/macros/s/AKfycbzNAzDGfS98zI-gLTxcCTPuVeg6rn2hGdtL2tkM/exec',
  adminSlackBotUrl: 'https://europe-west1-hummingbirdtech-production.cloudfunctions.net/admin-slack-bot',
  slackChannelApplicationFileDownload: 'C02114XCWS2',
  slackChannelFlightRequest: 'C02NZNK22UE',
  platformAnalyticsCode: '',
  freshAnalyticsCode: '',
  bucket: 'hbt-staging-ortho-raw',
  indexedDBName: 'HummingbirdUploaderStore'
};
export default Staging;